import { render } from "./AppMyProfilePage.vue?vue&type=template&id=2d50b2d0&ts=true"
import script from "./AppMyProfilePage.vue?vue&type=script&lang=ts"
export * from "./AppMyProfilePage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__